import React from 'react';
import moment from 'moment';

import { FileBox, MCButton } from 'src/components/basic';

import { countFormat, lang, remCss, scssVariables, withRouter } from 'src/helpers';
import SVGIcon, { BASE_ICONS, GENERAL_ICONS } from '../svg';

class TimelineItem extends React.PureComponent {
  state = {
    width: remCss(80)
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateWidthWindow);
    this.updateWidthWindow();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidthWindow);
  }

  updateWidthWindow = () => {
    const el = document.getElementsByClassName('mc-chat');
    if (el.length) {
      const clientWidth = el[0].clientWidth;
      this.setState({ width: clientWidth * 0.7 });
    } else {
      this.setState({ width: remCss(80) });
    }
  };

  getPeriod = (day) => {
    const diff = moment().diff(moment(day), 'days');
    if (diff === 0) {
      return lang.t('Today');
    }
    if (diff === 1) {
      return lang.t('Yesterday');
    }
    if (diff < 30) {
      return lang.t(diff + ' days ago');
    }
    if (diff < 365) {
      return lang.t('A few months ago');
    }
    return '';
  };

  render() {
    let {
      auth,
      items,
      item,
      fromChat,
      index,
      onEdit,
      onDelete,
      onForward,
      onReply,
      onLike,
      screenDetail
    } = this.props;
    let title = item.text;
    let description = typeof item.data == 'string' ? item.data : item.data?.description;
    let { media = [] } = item;

    let day = moment(item.date).format('DD-MMMM-YYYY');
    let prevItemDay = items && index > 0 && moment(items[index - 1].date).format('DD-MMMM-YYYY');
    let nextItemDay =
      items && index < items.length - 1 && moment(items[index + 1].date).format('DD-MMMM-YYYY');

    if (fromChat) {
      return (
        <div className={'mc-flex-col'}>
          <div className={'mc-value-616'}>{title}</div>
          <pre className={'mc-label-416'}>{description}</pre>
          <div className={'mc-flex mc-wrap'}>
            {media.map((file, index) => (
              <FileBox
                list={media}
                key={'mc-media-' + index}
                file={file}
                onClose={null}
                styles={{ width: remCss(150), height: remCss(150) }}
                onlyPreview={true}
                showFileName={false}
              />
            ))}
          </div>
        </div>
      );
    }
    return (
      <div data-testid='timeline-item' className={'mc-list-item'}>
        {items && prevItemDay !== day && (
          <div className={'mc-flex mc-list-item-time mc-mb20'}>
            <div className={'mc-grow mc-value-622'}>{this.getPeriod(item.date)}</div>
            <div className={'mc-value-622'}>{day}</div>
          </div>
        )}
        <div
          className={'mc-list-item-box mc-pb40' + (items && nextItemDay === day ? ' mc-bl' : '')}
        >
          <div className={'mc-icon'}>
            <SVGIcon iconname={'heart-icon'} />
          </div>
          <div className={'mc-flex-15-col mc-grow'}>
            <div className={'mc-content-wrap'}>
              <SVGIcon
                iconname={'arrow-icon'}
                strokeWidth={0.5}
                fill={scssVariables['colors-mc-border2']}
              />
              <div className={'mc-value-622'}>{title}</div>
              <pre className={'mc-label-420'}>{description}</pre>
              <div className={'mc-flex mc-wrap'}>
                {media.map((file, index) => (
                  <FileBox
                    list={media}
                    key={'mc-media-' + index}
                    file={file}
                    onClose={null}
                    styles={{ width: remCss(150), height: remCss(150) }}
                    onlyPreview={true}
                    showFileName={false}
                  />
                ))}
              </div>
            </div>
            <div className={`mc-flex${screenDetail.isMediumScreen ? '-col' : ''}`}>
              <div className={`mc-flex mc-grow mc-wrap`}>
                {auth?.id !== item.from && (
                  <MCButton
                    small
                    primary
                    light
                    radius
                    iconname={GENERAL_ICONS.REPLY}
                    onClick={onReply}
                    label={'Reply'}
                  />
                )}
                {auth?.id === item.from && (
                  <MCButton
                    small
                    primary
                    light
                    radius
                    iconname={GENERAL_ICONS.FORWARD}
                    onClick={onForward}
                    label={'Forward'}
                  />
                )}
                <MCButton
                  small
                  light
                  radius
                  primary
                  iconname={BASE_ICONS.LIKE}
                  onClick={onLike}
                  label={
                    lang.t((item.likedUserIds || []).indexOf(auth.id) > -1 ? 'Liked' : 'Like') +
                    '(' +
                    countFormat(item.likedCount || 0) +
                    ')'
                  }
                />
                {auth?.id === item.from && (
                  <>
                    <MCButton
                      small
                      light
                      radius
                      primary
                      iconname={BASE_ICONS.EDIT}
                      onClick={onEdit}
                      label={'Edit'}
                    />
                    <MCButton
                      small
                      light
                      radius
                      secondary
                      iconname={BASE_ICONS.DELETE}
                      onClick={onDelete}
                      label={'Delete'}
                    />
                  </>
                )}
              </div>
              <div className={'mc-label-418'}>{moment(item.date).format('hh:mm a')}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(TimelineItem);
